import type { OptionObject } from '../Select';

export type RadioGroupProps = {
  id?: string;
  testId?: string;
  title?: string;
  options: OptionObject[];
  orientation: RadioGroupOrientation;
  label: string;
  defaultValue?: string;
  name?: string;
};

export enum RadioGroupOrientation {
  horizontal = 'horizontal',
  vertical = 'vertical',
}
